// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__pRztB","buttons":"PendingPaymentAlert_buttons__22Kif"};